// Service
import LocalStorage from '../Data/Services/Storage/LocalStorage';
// Types
import * as CoreTypes from '../Data/Models/Core.type';
// Utils
import CommonUrls from '../Data/Services/CommonUrls';
// Common
import Common from '../../App/Resources/Common';

export interface IPostParams {
  key: string;
  value: string | number;
}

export default class ServicesUtils {
  static getHeaders(needAuth = false): Headers {
    const headers = new Headers({});

    headers.append('Accept', 'application/json');
    if (needAuth) {
      // const token = LocalStorage.get(LocalStorage.keys.access_token);
      // const bearer = `Bearer ${token}`;
      // headers.append('Authorization', bearer);
    }
    return headers;
  }

  static get(
    url: string,
    needAuth: boolean = true,
    signal: AbortSignal | undefined = undefined
  ): Promise<any> {
    const headers = this.getHeaders(needAuth);
    headers.append('Content-Type', 'application/json; charset=utf-8');

    const init: RequestInit = {
      headers,
      method: 'GET',
      mode: 'cors',
      cache: 'default',
    };

    if (signal) {
      init.signal = signal;
    }

    return ServicesUtils.callUrl(url, init);
  }

  static postForm(url: string, data: any, needAuth = true): Promise<any> {
    const headers = this.getHeaders(needAuth);
    headers.append(
      'Content-Type',
      'application/x-www-form-urlencoded; charset=utf-8'
    );

    const init: RequestInit = {
      headers,
      method: 'POST',
      mode: 'cors',
      cache: 'default',
      body: Object.keys(data).reduce(
        (params: string, key: string, index: number) =>
          `${params}${index > 0 ? '&' : ''}${key}=${data[key]}`,
        ''
      ),
    };

    const redirectIf401: boolean = url === CommonUrls.getLogin() ? false : true;

    return ServicesUtils.callUrl(url, init, redirectIf401);
  }

  static postFormData(
    url: string,
    data: any,
    params: any = {},
    needAuth: boolean = true
  ): Promise<any> {
    const headers = this.getHeaders(needAuth);
    const formData: FormData = new FormData();
    Object.keys(data).forEach((k: string) => formData.append(k, data[k]));

    const init: RequestInit = {
      headers,
      ...params,
      method: 'POST',
      mode: 'cors',
      cache: 'default',
      body: formData,
    };

    const redirectIf401: boolean = url === CommonUrls.getLogin() ? false : true;

    return ServicesUtils.callUrl(url, init, redirectIf401);
  }

  static postJSON(url: string, data: any, needAuth = true): Promise<any> {
    const headers = this.getHeaders(needAuth);
    headers.append('Content-Type', 'application/json; charset=utf-8');

    const init: RequestInit = {
      headers,
      method: 'POST',
      mode: 'cors',
      cache: 'default',
      body: JSON.stringify(data),
    };

    const redirectIf401: boolean = url === CommonUrls.getLogin() ? false : true;

    return ServicesUtils.callUrl(url, init, redirectIf401);
  }

  static put(url: string, data: any, needAuth = true): Promise<any> {
    const headers = this.getHeaders(needAuth);
    headers.append('Content-Type', 'application/json; charset=utf-8');

    const init: RequestInit = {
      headers,
      method: 'PUT',
      mode: 'cors',
      cache: 'default',
      body: JSON.stringify(data),
    };

    const redirectIf401: boolean = url === CommonUrls.getLogin() ? false : true;

    return ServicesUtils.callUrl(url, init, redirectIf401);
  }

  static delete(url: string, needAuth = true): Promise<any> {
    const headers = this.getHeaders(needAuth);
    headers.append('Content-Type', 'application/json; charset=utf-8');

    const init: RequestInit = {
      headers,
      method: 'DELETE',
      mode: 'cors',
      cache: 'default',
    };

    return ServicesUtils.callUrl(url, init);
  }

  static callUrl(url: string, init: RequestInit, redirectIf401 = true) {
    const defaultMessage = 'Une erreur est survenue...';
    return fetch(url, init)
      .catch(() => {
        throw defaultMessage;
      })
      .then((response: any) => {
        const statusCode: number | boolean = ServicesUtils.handleErrors(
          response,
          redirectIf401
        );

        if (statusCode !== false) {
          return response.json().then((data: CoreTypes.IWsException) => {
            throw data;
          });
        }

        return response.json();
      });
  }

  static handleErrors(response: { status?: number }, redirect = true) {
    if (!response || !response.status || response.status > 299) {
      if (response && response.status === 401 && redirect) {
        LocalStorage.delete(LocalStorage.keys.userId);
        window.location.href = `/${Common.Routes.routeLogin}`;
      }
      return response.status || 1;
    }
    return false;
  }
}
